export const parseStringToFloat = (value: string) => {
  const parsed = value.replace(/\./g, '').replace(',', '.');

  return Number.parseFloat(parsed);
};
